import { API_BASE_URLS } from '@/constants';

import { createApiClient } from './apiClient';

const coreApiService = createApiClient({
  baseURL: API_BASE_URLS.BASE_URL,
});

const cdfiApiService = createApiClient({
  baseURL: API_BASE_URLS.CDFI_API_URL,
});

const dataManagementApiService = createApiClient({
  baseURL: API_BASE_URLS.DATA_MANAGEMENT_API_URL,
});

export const apiServices = { cdfiApiService, dataManagementApiService, coreApiService };
